import React, { useState, useEffect } from 'react'
import { FormGroup, Panel, Input, Row, Col, Checkbox } from 'rsuite'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import HTMLWidget from '../../../widgets/HTMLWidget'
import AppContext from '../../../context/AppContext'
import { color } from 'echarts'

export default function ProposalReviseView({
  schema: _schema,
  disabledForm = false,
}) {
  const [schema, setSchema] = useState(_schema)

  const { theme } = React.useContext(AppContext)

  const renderPanel = (panel, index) => {
    return (
      <Panel header={panel.label} collapsible defaultExpanded key={panel.id}>
        <>
          {panel.subItems.map((subject, index) => {
            return renderSubject(subject, index)
          })}
        </>
      </Panel>
    )
  }

  const renderSubject = (subject, index) => {
    return (
      subject?.selected && (
        <Row key={subject.id} style={{ marginTop: 0 }}>
          <Col md={23} style={{ padding: '0px', marginTop: -10 }}>
            <Panel header={subject.label} defaultExpanded expanded={subject.selected}>
              <FormGroup>
                {subject.subItems.length === 0 ? (
                  subject.selected && (
                    <>
                      {subject.enableInput ? (
                        <>
                          <Input
                            name={subject.id}
                            componentClass="textarea"
                            rows={3}
                            style={{
                              width: '100%',
                              resize: 'auto',
                              marginTop: 0,
                              color: theme[0] === 'default' ? '#000' : '#fff',
                            }}
                            placeholder={subject.placeholder}
                            defaultValue={subject.value}
                            disabled={!subject.enableInput || disabledForm}
                          />
                        </>
                      ) : (
                        <HTMLWidget
                          style={{ marginLeft: 30, marginTop: -20 }}
                          data={subject.value}
                        />
                      )}
                    </>
                  )
                ) : (
                  <>
                    {subject.subItems.map((sub, index) => {
                      return renderSub(sub, index)
                    })}
                  </>
                )}
              </FormGroup>
            </Panel>
          </Col>
        </Row>
      )
    )
  }

  const renderSub = (sub, index) => {
    return (
      <Row key={index}>
        {sub.selected && (
          <Row style={{ marginLeft: 30 }}>
            {sub.enableInput ? (
              <>
                <Input
                  name={sub.id}
                  componentClass="textarea"
                  defaultValue={sub.value}
                  disabled={!sub.enableInput || disabledForm}
                  placeholder={sub.placeholder}
                />
              </>
            ) : (
              <HTMLWidget data={sub.value} />
            )}
          </Row>
        )}
      </Row>
    )
  }

  return (
    <>
      {schema &&
        schema.map((panel, index) => {
          return renderPanel(panel, index)
        })}
    </>
  )
}
